// import fs from 'fs';

export default function (Site, $) {
  Site.widget("related-info", {
    _create() {
      this.element.find(".btn-toggle").click((e) => {
        this.element.toggleClass("collapsed");
      });
    },
  });
}
